import { DashboardInsightFragment } from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import useLabel from "@apps/use-label/use-label";
import { assertNonNull } from "@helpers/helpers";

import { InsightButton, InsightLayout } from "../insight";

const SurveyInsight = ({
  insight,
  onDismissInsight,
  selectedUser,
}: {
  insight: DashboardInsightFragment;
  onDismissInsight: () => void;
  selectedUser: BasicUser;
}) => {
  const label = useLabel();
  const complianceProgram = assertNonNull(insight.complianceProgram);

  return (
    <InsightLayout
      user={selectedUser}
      onDismissInsight={onDismissInsight}
      isRequired={!!insight.complianceProgram?.id}
    >
      <div className="flex-1">
        <div>
          Complete your {label("survey")}
          {": "}
          {complianceProgram.title}
        </div>
      </div>
      <div>
        <InsightButton url="/survey">
          Go to {label("survey", { pluralize: true })}
        </InsightButton>
      </div>
    </InsightLayout>
  );
};

export default SurveyInsight;
